module.exports = __webpack_public_path__ + "static/media/checkatrade-no-strapline.ebbc77cb.png";